import { useEffect } from 'react';
import { generateMetaTags } from '../config/meta';

const usePageMeta = (pageMeta = {}) => {
  useEffect(() => {
    const meta = generateMetaTags(pageMeta);
    
    // Update title
    document.title = meta.title;
    
    // Update meta tags
    const updateMetaTag = (name, content) => {
      let element = document.querySelector(`meta[name="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('name', name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    const updatePropertyMetaTag = (property, content) => {
      let element = document.querySelector(`meta[property="${property}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('property', property);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Update basic meta tags
    updateMetaTag('description', meta.description);
    updateMetaTag('keywords', meta.keywords);
    updateMetaTag('author', meta.author);
    updateMetaTag('language', meta.language);

    // Update Open Graph meta tags
    updatePropertyMetaTag('og:title', meta['og:title']);
    updatePropertyMetaTag('og:description', meta['og:description']);
    updatePropertyMetaTag('og:url', meta['og:url']);
    updatePropertyMetaTag('og:image', meta['og:image']);
    updatePropertyMetaTag('og:site_name', meta['og:site_name']);
    updatePropertyMetaTag('og:locale', meta['og:locale']);

    // Update Twitter Card meta tags
    updatePropertyMetaTag('twitter:title', meta['twitter:title']);
    updatePropertyMetaTag('twitter:description', meta['twitter:description']);
    updatePropertyMetaTag('twitter:image', meta['twitter:image']);

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', meta['og:url']);

  }, [pageMeta]);
};

export default usePageMeta; 